import { AvailableTabs } from 'constants/SidebarTabs';
import { NormalizedLoad } from 'types/Load';

import { getCurrentUrl } from './current-url';
import { TMSHost } from './interface';

export class GlobalTranz implements TMSHost {
  private getCurrentUrl: () => string;

  constructor(getCurrentUrlFn?: () => string) {
    this.getCurrentUrl = getCurrentUrlFn || getCurrentUrl;
  }

  getFieldMoniker(key: keyof NormalizedLoad): string {
    switch (key) {
      case 'externalTMSID':
        return '';
      case 'freightTrackingID':
        return 'BOL #';
      default:
        return '';
    }
  }

  parseFreightTrackingID(): string {
    const url = this.getCurrentUrl();
    const match = url.match(/\/tl\/sales-order\/(\d+)(?:\/|[?#]|$)/);
    if (match) {
      return match[1];
    }
    return '';
  }

  parseExternalTMSID(): string {
    return this.parseFreightTrackingID();
  }

  determineDefaultLoadTab(): AvailableTabs {
    return AvailableTabs.LoadInformation;
  }

  shouldShowDrumkitOpener(): boolean {
    const url = this.getCurrentUrl();
    return (
      url.includes('/tl/sales-order/') || url.includes('sales-order-board')
    );
  }
}
